var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-install-wrap"},[_c('img',{attrs:{"src":require("@/assets/img/img_menu_bi.png")}}),_c('p',[_c('span',[_vm._v("배달비 무료!")]),_c('br'),_vm._v(" 모든오더로 배달비 0원의"),_c('br'),_vm._v(" 혜택을 마음껏 누리세요 ")]),_c('div',{staticClass:"app-loading-info"},[_vm._v(" 앱 스토어로 이동중입니다 ")])])
}]

export { render, staticRenderFns }